import { Member } from '@/features/iam/members/Member'
import { Id } from '@/infra/id'
import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'

export type ParticipantProps = ModelProps<Participant>

/**
 * A member taking part in a conversation.
 */
export class Participant extends Model<Participant> {
  userPublicId = Id.none

  @observable accessor type: ParticipantType = 'Member'
  @observable accessor member = Member.none
  @observable accessor active = false
  @observable accessor online = false
  @observable accessor lastSeen: Date | null = null
  @observable accessor muted = false
}

/**
 * Whether a participant takes part as an admin or as a member.
 */
export type ParticipantType = 'Admin' | 'Member'
